import { useToggle } from "react-use"

import { deletePaymentMethods, PaymentMethod } from "modules/ClientAccount/utils"
import { Analytics } from "utils/analytics"
import { Button, Dropdown, Headline3, Modal, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { PaymentIcon } from "components/PaymentIcon"

interface Props {
    card: PaymentMethod
    reFetchCardList: () => void
}

export function CardItem({ card, reFetchCardList }: Props) {
    const [isModalOpen, toggleModal] = useToggle(false)

    const handleRemoveCard = (external_id: string) => {
        void deletePaymentMethods(external_id).finally(() => reFetchCardList())
        Analytics.card_remove()
    }

    return (
        <div className="card-list-item">
            <div className="card-list-item__card-icon">
                <PaymentIcon cardName={card?.card_type} />
            </div>
            <Icon type="four-dots-unselected" size="28" />
            <div className="card-list-item__last-card-digits">
                &nbsp;{card.card_mask?.slice(-4)}
            </div>
            <Dropdown
                className="card-list-item__more-menu"
                icon={<Icon type="more-vertical" size="24" />}
                offTriggerClassName={true}
            >
                <div className="card-list-item__remove-card" onClick={toggleModal}>
                    Удалить карту
                </div>
            </Dropdown>
            <Modal onBackgroundClick={toggleModal} isActive={isModalOpen}>
                <Modal.Content
                    isFullHeightMobile
                    onCloseClick={toggleModal}
                    data-testid="clientacc-remove-card-modal"
                >
                    <Headline3 className="is-weight-medium remove-card-modal__title">
                        Удалить карту?
                    </Headline3>
                    <div className="remove-card-modal__text-block text-align-center">
                        <Text isAccent>
                            Вы&nbsp;собираетесь удалить карту, заканчивающуюся&nbsp;на&nbsp;
                            {card.card_mask?.slice(-4)}.
                        </Text>
                        <br />
                        <Text>
                            После&nbsp;удаления карты вам придется заново вводить ее данные при
                            оплате. Alter не&nbsp;хранит данные ваших сохраненных&nbsp;карт.
                        </Text>
                    </div>
                    <div className="remove-card-modal__button-block">
                        <Button
                            className="remove-card-modal__button-block__button"
                            onClick={toggleModal}
                        >
                            Оставить
                        </Button>
                        <Button
                            color="danger"
                            className="remove-card-modal__button-block__button"
                            onClick={() => handleRemoveCard(card.external_id)}
                        >
                            Удалить карту
                        </Button>
                    </div>
                </Modal.Content>
            </Modal>
        </div>
    )
}
